// extracted by mini-css-extract-plugin
export default {"main":"Main_main__y6Db6","layout":"Main_layout__Uz4KH","side-menu":"Main_side-menu__vFp2i","body":"Main_body__1yROR"};